// removed by extract-text-webpack-plugin
module.exports = {"EmailSignupForm":"EmailSignupForm__-loca-__1gVWn","Text":"EmailSignupForm__-loca-__1NNKA","SocialMediaArea":"EmailSignupForm__-loca-__280q-","SocialMessage":"EmailSignupForm__-loca-__1DEpJ","Icon":"EmailSignupForm__-loca-__3xNU0"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/EmailSignupForm/EmailSignupForm.css
// module id = 221
// module chunks = 0